import * as React from 'react';
import * as _ from 'underscore';

import { IGlob } from '../../ts/Glob';
import { createNodeID, IExportStore, parseNodeID } from '../../../../_common/platform/ts/exportImportDispatcher';
import { ITreeNode } from '../../ts/Interfaces';

import {
    AppSettingsFlatCheckList,
    IMarkedItemsBoolean
} from '../../../../pdc-platform/src/tsx/AppSettingsFlatCheckList';

export interface IEntityModelExportData {
    dataSources?: number[];
}

export function EntityModelExport(props: {
    value: { dataSources: number[] };
    glob: IGlob;
    onChange?(value: IEntityModelExportData, selectedItems: any[]): void;
}) {
    props.glob.EntityModelsStore.useLoadDataSourcesHook();
    const [value, setValue] = React.useState<number[]>(props.value?.dataSources);

    const handleOnChange = React.useCallback(
        (marked: IMarkedItemsBoolean) => {
            const newValue = Object.keys(marked).map((key) => parseInt(key));

            setValue(newValue);

            if (props.onChange != null) {
                props.onChange({ dataSources: newValue }, newValue);
            }
        },
        [props.onChange]
    );

    const dataSources = props.glob.EntityModelsStore.getDataSources();

    let valuesToSort = _.map(dataSources, (dataSource) => {
        return {
            id: dataSource.dataSourceID,
            name: dataSource.name,
            idSort: dataSource.name.toLowerCase()
        };
    });

    valuesToSort = _.sortBy(valuesToSort, 'idSort');

    const values = _.map(valuesToSort, (value) => {
        return {
            key: value.id.toString(),
            value: value.name
        };
    });

    const marked: IMarkedItemsBoolean = {};

    _.each(value, (item) => {
        marked[item.toString()] = true;
    });

    return (
        <div className="app-settings-export">
            <AppSettingsFlatCheckList value={values} marked={marked} onChange={handleOnChange} />
        </div>
    );
}

export const ENTITY_MODEL_EXPORT_ID = 'entityModel';

const ENTITY_MODEL_TYPE = 'em';

export class EntityModelExportStore implements IExportStore {
    private _glob: IGlob;

    constructor(glob: IGlob) {
        this._glob = glob;
    }

    public get descriptionID(): string {
        return ENTITY_MODEL_EXPORT_ID;
    }

    public createExportData(values: string[]) {
        const result: IEntityModelExportData = {};
        const dataSources: number[] = [];

        values?.forEach((value) => {
            const { type, id } = parseNodeID(value);

            if (type === ENTITY_MODEL_TYPE) {
                dataSources.push(parseInt(id));
            }
        });

        if (dataSources.length > 0) {
            result.dataSources = dataSources;
        }

        return result;
    }

    public async getItemsToExport(): Promise<ITreeNode[]> {
        return new Promise((resolve, reject) => {
            const dataSources = this._glob.EntityModelsStore.getDataSources();

            let valuesToSort = _.map(dataSources, (dataSource) => {
                return {
                    id: dataSource.dataSourceID,
                    name: dataSource.name,
                    idSort: dataSource.name.toLowerCase()
                };
            });

            valuesToSort = _.sortBy(valuesToSort, 'idSort');

            const result = valuesToSort.map<ITreeNode>((value) => {
                const nodeID = createNodeID(ENTITY_MODEL_EXPORT_ID, ENTITY_MODEL_TYPE, value.id.toString());

                return {
                    key: nodeID,
                    id: nodeID,
                    title: value.name,
                    parentId: ENTITY_MODEL_EXPORT_ID
                };
            });

           resolve(result);
        });
    }
}
